import { takeEvery, all, put, call, select } from 'redux-saga/effects';
import * as types from './types';
import * as actions from './actions';
import * as api from './api';
import { createRenewal } from '../purchases/sagas';
import {
  destroy as destroyPurchase,
  createRenewal as renewalAction
} from '../purchases/actions';
import { getRenewalPurchase } from 'reducers';

export function* getAllocations({ payload: { userId, page } }) {
  const pageSize = 500;
  try {
    const resp = yield call(api.getAllocations, userId, page, pageSize);
    yield put(actions.getAllocationsSucceeded(resp));
    if (resp.data.next) {
      yield put(actions.getAllocations(userId, page + 1));
    }
  }
  catch (err) {
    yield put(actions.getAllocationsFailed(page));
  }
}

export function* getBypassedAllocations({ payload: { userId, page } }) {
  const pageSize = 500;
  try {
    const resp = yield call(api.getBypassedAllocations, userId, page, pageSize);
    yield put(actions.getBypassedAllocationsSucceeded(resp));
    if (resp.data.next) {
      yield put(actions.getBypassedAllocations(userId, page + 1));
    }
  }
  catch (err) {
    yield put(actions.getBypassedAllocationsFailed(page));
  }
}

export function* getQuickAllocations({ payload: { userId, page } }) {
  const pageSize = 500;
  try {
    const resp = yield call(api.getQuickAllocations, userId, page, pageSize);
    yield put(actions.getQuickAllocationsSucceeded(resp));
    if (resp.data.next) {
      yield put(actions.getQuickAllocations(userId, page + 1));
    }
  }
  catch (err) {
    yield put(actions.getQuickAllocationsFailed(page));
  }
}

export function* watchGetAllocations() {
  yield takeEvery(types.GET_ALLOCATIONS, getAllocations);
}

export function* watchgetBypassedAllocations() {
  yield takeEvery(types.GET_BYPASSED_ALLOCATIONS, getBypassedAllocations);
}

export function* watchGetQuickAllocations() {
  yield takeEvery(types.GET_QUICK_ALLOCATIONS, getQuickAllocations);
}

export function* checkRenewal({ payload: { userId } }) {
  yield call(createRenewal, renewalAction(userId));
  const purchase = yield select(getRenewalPurchase);
  if (purchase) {
    yield put(destroyPurchase(purchase.id));
  }
}

export function* watchCheckRenewal() {
  yield takeEvery(types.CHECK_RENEWAL, checkRenewal);
}

export function* watchRenewal() {
  yield all([
    call(watchGetAllocations),
    call(watchgetBypassedAllocations),
    call(watchGetQuickAllocations),
    call(watchCheckRenewal),
  ]);
}
